var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUaeFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4658_25750",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.5H0V13.5H18V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4658_25750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0.5H0V13.5H18V0.5Z",
    fill: "#00732F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4.83398H0V13.5007H18V4.83398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9.16602H0V13.4993H18V9.16602Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.5H0V13.5H4.5V0.5Z",
    fill: "#FF0000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUaeFlag);
export default __webpack_public_path__ + "static/media/uae_flag.e447492d697f221308c16900050e4c0b.svg";
export { ForwardRef as ReactComponent };